// Environment-aware logger utility
// Only logs in development mode to prevent information leakage in production

const isDev = typeof import.meta !== 'undefined' &&
  ((import.meta as any).env?.DEV || (import.meta as any).env?.MODE === 'development');

export const logger = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },

  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  // Production-safe error logging (no sensitive data)
  prodError: (message: string, context?: Record<string, any>) => {
    console.error(message, context ? { context } : '');
  }
};

// Export type for usage
export type Logger = typeof logger;
